import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "cse-aiml-resources",
  department: "Computer Science & Engineering (AI & ML)",
  short: "CSE (AI & ML)",
  programmePath: "/programme/cse-aiml",
  description: "Student Resources for the Department of Computer Science & Engineering (AI & ML).",
  resourceSet: "aiml",
  sections: [
    {
      title: "Syllabus",
      items: [
        {
          label: "IA Coverage",
          href: "https://drive.google.com/file/d/1HZyF9jYEbuacUdFDZld5Gx3WgYvZzeEz/view?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th Semester TimeTable",
          href: "/student_resources/AIML/TimeTable/iv-tt.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th Semester TimeTable",
          href: "/student_resources/AIML/TimeTable/vi-tt.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
      {
          label: "2nd & 4th Sem COE",
          href: "/student_resources/AIML/COE/II-AND-IV-SEM-COE-1.pdf",
        },
    ] },
    {
      title: "Lab Manuals",
      items: [
        {
          label: "Lab Manuals",
          href: "https://drive.google.com/drive/folders/1OanjIlq6P3FCShk3ra05wdBbI3FlEVky?usp=drive_link",
        },
        // {
        //   label: "2nd Sem (2025) Combined Lab Manual",
        //   href: "/StudentResources/AIML1/lab manual/2nd sem 2025 combined.pdf",
        // },
        // {
        //   label: " BAD402 (Artificial Intelligence) Lab Manual 2025-2026",
        //   //href: "/resources/student-resources/aiml/lab-manuals/4th-sem-cseaiml-lab-manual-2025-2026.pdf",
        // },
        // {
        //   label: "BCSL606 (Machine Learning) Lab Manual",
        //   //href: "/resources/student-resources/aiml/lab-manuals/6th-sem-lab-manual.pdf",
        // },
        // {
        //   label: "BAI358 (PHP) Lab Manual",
        //   //href: "/resources/student-resources/aiml/lab-manuals/bai358-php-lab-manual.pdf",
        // },
        // {
        //   label: "BAIL504 (DVL) Lab Manual",
        //   //href: "/resources/student-resources/aiml/lab-manuals/bail504-dvl-lab-manual.pdf",
        // },
        // {
        //   label: "BCS303 (Operating System) Lab Manual",
        //   //href: "/resources/student-resources/aiml/lab-manuals/bcs303-operating-system-lab-manual.pdf",
        // },
        // {
        //   label: "BCSL305 (Data Structures) Lab Manual",
        //   //href: "/resources/student-resources/aiml/lab-manuals/bcsl305-ds-lab-manual.pdf",
        // },
        // {
        //   label: "BAI702 (Machine Learning 2) Lab Manual 1",
        //   //href: "/resources/student-resources/aiml/lab-manuals/ml2-lab-manual-1.pdf",
        // },
      ],
    },
    {
      title: "Question Papers & Solutions",
      items: [
        {
          label: "Question Paper and Solution",
          href: "https://drive.google.com/drive/folders/1TG_A9n-uVSjGjj7Z063prmm8UcZqXeOL?usp=drive_link",
        },
      ],
    },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "https://drive.google.com/drive/folders/1Gkpnwdcqlg5e4KLDBAvvys-ndcBNiMs9?usp=drive_link",
        },
      ],
    },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: "Published Papers & Patents",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor Mentee List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/AIML/MentorMentee/Montor mentee 2025-26.pdf",
        },
      ],
    },
  ],
};

const AIMLResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default AIMLResources;
